<template>
  <div class="amazon_edit" style="width: 90%">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right; margin: 0 0 8px 0; padding-top: 10px">
      <el-button @click="handleQuit()" size="small">取消</el-button>
      <el-button
        v-if="!isView"
        @click="handleSaveForm"
        size="small"
        type="primary"
        >{{ upload == "1" ? "保存待上传" : "保存汇出记录" }}</el-button
      >
    </div>
    <el-form ref="form" label-width="200px" :model="form">
      <div id="selectTemplate" class="basic">
        <div class="title">选择模板</div>
        <el-form-item label="汇出产品：">
          {{ productName }}
        </el-form-item>
        <el-form-item label="汇出产品数：">
          {{ productName.split("，").length }}
        </el-form-item>
        <el-form-item
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="shopId"
          label="所属店铺："
        >
          <el-select
            clearable
            filterable
            style="width: 100%"
            size="mini"
            v-model="form.shopId"
            placeholder="请选择所属店铺"
            @change="handleChangeShop"
          >
            <el-option-group
              v-for="group in shopList"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.shopList"
                :key="item.value"
                :label="item.shopName"
                :value="item.shopId"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="
            platName == 'common' ||
              platName == 'lazada' ||
              platName == 'shopee' ||
              platName == 'tiktok'
          "
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="templateId"
          label="汇出范本："
        >
          <el-select
            clearable
            filterable
            style="width: 100%"
            size="mini"
            v-model="form.templateId"
            placeholder="请选择汇出范本"
          >
            <el-option
              v-for="(record, index) in templateList"
              :key="index"
              :label="record.templateName"
              :value="record.templateId"
            >
            </el-option>
          </el-select>
          <div style="position: absolute;right: -100px;top: 2px;">
            <a style="cursor:pointer;" @click.prevent="handleJump">模板设置</a>
          </div>
        </el-form-item>
        <el-form-item
          v-else
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
          prop="productPicAddr"
          label="同步产品图片地址："
        >
          <el-select
            clearable
            style="width: 100%"
            size="mini"
            v-model="form.productPicAddr"
            placeholder="请选择产品图片地址"
          >
            <el-option
              v-for="(record, index) in pictureAddresses"
              :key="index"
              :label="record"
              :value="record"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>

    <Template
      v-if="form.templateId"
      :remitData="remitData"
      :designId="form.designId"
      :templateId="form.templateId"
      :shopId="form.shopId"
      :amazonSite="amazonSite"
      :isMainland="form.isMainland"
      ref="template"
      @save="handleSaveForm"
      @submit="handleSubmit"
    ></Template>
  </div>
</template>

<script type="text/ecmascript-6">
import Template from './createTemplate.vue'
import { getTemplateList, delTemplate } from "@/api/template/universal";
import { getShopList } from "@/api/shop/shop";
import Breadcrumb from "@/components/common/Breadcrumb";
import { getConfigKey } from "@/api/system/config";
import { addTemplateRemit, getRemitInfo } from "@/api/template/template";
import { getDomainList, } from "@/api/system/domain"
export default {
  name: "createTemplateData",
  components: { Template, Breadcrumb },
  data() {
    return {
      form: {
        shopId: '',
        templateId: '',
        designId: '',
        productPicAddr: '',
        platNo: '',
        isMainland: ''
      },
      productName: '',
      templateList: [],
      shopList: [],
      priceConfigVisible: true,
      platName: '',
      pictureAddresses: [],
      upload: '0',
      remitData: {},
      amazonSite: '',
      shopArray: [],
      isSave: false
    };
  },
  watch: {
    'form.shopId'() {
      if(this.shopArray && this.shopArray.length > 0){
        for(let record of this.shopArray){
          if(record.shopId == this.form.shopId){
            this.amazonSite = record.amazonSite
            this.form.isMainland = record.isMainland
            break
          }
        }
      }
    }
  },
  computed: {
    isView(){
      return this.$route.query.isView === '1'
    }
  },
  methods: {
    getConfigKey(){
      getConfigKey("pic_url")
        .then(async (res) => {
          if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleChangeShop(){

    },
    async getShopList(){
      let platName = this.$route.query.platName ? this.$route.query.platName : 'amazon'
      let upload = this.$route.query.upload
      let params = upload == "1" ? {authStatus: '02', shopStatus: '01'} : {}
      let platNo = this.$route.query.platNo
      if(platNo == '05'){
        params.isMainaccount = '01'
      }

      let result = await getShopList(params)
       let shopList = []
       this.shopArray = JSON.parse(JSON.stringify(result.rows))
      if(platName == 'common'){
        shopList = [{ label: '亚马逊店铺' , shopList: []},
          { label: 'shopify' , shopList: []},
          { label: 'shopline' , shopList: []},
          { label: '店匠' , shopList: []},
          { label: '其他店铺' , shopList: []},
          { label: 'lazada' , shopList: []},
          { label: 'shopee' , shopList: []},
           { label: 'tiktok' , shopList: []}]
        for(let record of result.rows){
          if(record.platNo == '04'){
            shopList[0].shopList.push(record)
          } else if(record.platNo == '06'){
            shopList[1].shopList.push(record)
          } else if(record.platNo == '07'){
            shopList[2].shopList.push(record)
          }  else if(record.platNo == '08'){
            shopList[3].shopList.push(record)
          } else if(record.platNo == '09'){
            shopList[4].shopList.push(record)
          } else if(record.platNo == '03'){
            shopList[5].shopList.push(record)
          } else if(record.platNo == '05'){
            shopList[6].shopList.push(record)
          }else if(record.platNo == '10'){
            shopList[7].shopList.push(record)
          }
        }
      }else {
        if(platName == 'amazon'){
          shopList.push({ label: '亚马逊店铺' , shopList: []})
        }else if (platName == 'shopify'){
          shopList.push({ label: 'shopify' , shopList: []})
        }else if (platName == 'shopline'){
          shopList.push({ label: 'shopline' , shopList: []})
        }else if (platName == 'shoplazza'){
          shopList.push({ label: '店匠' , shopList: []})
        }else if (platName == 'lazada'){
          shopList.push({ label: 'lazada' , shopList: []})
        }else if (platName == 'shopee'){
          shopList.push({ label: 'shopee' , shopList: []})
        }else if (platName == 'tiktok'){
          shopList.push({ label: 'tiktok' , shopList: []})
        }
        shopList.push({ label: '其他店铺' , shopList: []})

        for(let record of result.rows){
          if(record.platNo == '04' && shopList[0].label == '亚马逊店铺'){
            shopList[0].shopList.push(record)
          } else if(record.platNo == '06' && shopList[0].label == 'shopify'){
            shopList[0].shopList.push(record)
          } else if(record.platNo == '07' && shopList[0].label == 'shopline'){
            shopList[0].shopList.push(record)
          }  else if(record.platNo == '08' && shopList[0].label == '店匠'){
            shopList[0].shopList.push(record)
          } else if(record.platNo == '09'){
            shopList[1].shopList.push(record)
          }
           else if(record.platNo == '03' && shopList[0].label == 'lazada'){
            shopList[0].shopList.push(record)
          }
          else if(record.platNo == '05' && shopList[0].label == 'shopee'){
            shopList[0].shopList.push(record)
          }  else if(record.platNo == '10' && shopList[0].label == 'tiktok'){
            shopList[0].shopList.push(record)
          }
        }
      }


      this.shopList = shopList
    },
    async getTemplateList(){
      let platNo = this.$route.query.platNo
      let result = await getTemplateList({platNo: platNo})
      this.templateList = result.rows
    },
    handleJump(path) {
       let platNo = this.$route.query.platNo
       if(platNo == '03'){
        this.$router.push({ path: '/carry/lazada/lazada' })
       } else  if(platNo == '05'){
        this.$router.push({ path: '/carry/shopee/proTemplate' })
       } else  if(platNo == '10'){
        this.$router.push({ path: '/carry/tiktok/proTemplate' })
       } else{
        this.$router.push({ path: '/carry/common/template' })
       }
    },
    handleSaveForm(){
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let platName = this.$route.query.platName
            if(this.isSave){
                return
              }
            this.isSave = true
            if(platName == 'common' || platName == 'lazada' || platName == 'shopee' || platName == 'tiktok'){
              this.$refs['template'].handleSave()
              this.isSave = false
            } else{
              try {
              await addTemplateRemit(this.form)
              this.msgSuccess("汇出成功，请到汇出记录中下载");


              if(platName){
                if(platName == 'shopify'){
                  this.$router.push({
                    path: '/carry/shopify/shopfiyRemit'
                  })
                } else if(platName == 'shopline'){
                  this.$router.push({
                    path: '/carry/shopline/shoplineRemit'
                  })
                }else if(platName == 'shoplazza'){
                  this.$router.push({
                    path: '/carry/shoplazza/shoplazzaRemit'
                  })
                }else if(platName == 'lazada'){
                  this.$router.push({
                    path: '/carry/lazada/remitData'
                  })
                }else if(platName == 'shopee'){
                  this.$router.push({
                    path: '/carry/shopee/remitData'
                  })
                }else if(platName == 'tiktok'){
                  this.$router.push({
                    path: '/carry/tiktok/remitData'
                  })
                }
              }

            } catch (error) {

            }finally{
              this.isSave = false
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleSubmit(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      let platNo =  this.$route.query.platNo
      let upload = this.$route.query.upload
      if(upload == '1' && platNo == '03'){
        this.$router.push({
        path: '/carry/lazada/remitDataLazada'
        })
      }else if(upload == '1' && platNo == '05'){
        this.$router.push({
        path: '/carry/shopee/remitDataShopee'
        })
      }else if(upload == '1' && platNo == '10'){
        this.$router.push({
        path: '/carry/tiktok/remitDataTiktok'
        })
      }
      else if(pId){
        this.$router.push({
        path: '/product/amazon/remit'
        })
      }else if(designId){
        if(platNo == '03'){
          this.$router.push({
            path: '/carry/lazada/remitData'
          })
        } else if (platNo == '05'){
          this.$router.push({
            path: '/carry/shopee/remitData'
          })
        } else if (platNo == '10'){
          this.$router.push({
            path: '/carry/tiktok/remitData'
          })
        }
        else {
          this.$router.push({
          path: '/carry/common/remitData'
          })
        }
      }
    },
    handleQuit(){
      // let upload = this.$route.query.upload
      // let pageNum =  this.$route.query.pageNum
      // let platNo =  this.$route.query.platNo
      // if(upload && pageNum){
      //   if(platNo == '03'){
      //     this.$router.push({path: '/carry/lazada/remitDataLazada' , query : { pageNum : pageNum}})
      //   }else if(platNo == '05'){
      //     this.$router.push({path: '/carry/lazada/remitDataShopee' , query : { pageNum : pageNum}})
      //   }else if(platNo == '10'){
      //     this.$router.push({path: '/carry/lazada/remitDataTiktok' , query : { pageNum : pageNum}})
      //   }
      // }else {
        this.$router.go(-1)
      // }
    }
  },
 async mounted() {
    this.form.designId = this.$route.query.designId
    this.getShopList()
    await this.getTemplateList()
    let platName = this.$route.query.platName
    let upload = this.$route.query.upload
    let remitId = this.$route.query.remitId
    this.upload = upload
    if(platName){
      document.querySelectorAll('.el-breadcrumb__inner')[2].innerHTML = (platName == 'shoplazza' ? '店匠' : platName) + '汇出'
      document.querySelectorAll('.el-breadcrumb__inner')[1].innerHTML = (platName == 'shoplazza' ? '店匠' : platName)
      this.platName = platName
      if(platName == 'shopify'){
        this.form.platNo = '06'
      } else if(platName == 'shopline'){
        this.form.platNo = '07'
      }else if(platName == 'shoplazza'){
        this.form.platNo = '08'
      }else if(platName == 'lazada'){
        this.form.platNo = '03'
      }else if(platName == 'shopee'){
        this.form.platNo = '05'
      }
    }
    if(remitId){
      let result = await getRemitInfo(remitId)
      let find = false
      for(let record of this.templateList){
        if(record.templateId == result.data.templateId){
          find = true
          break
        }
      }
      if(find){
        this.form.templateId = result.data.templateId
      }
      this.form.shopId = result.data.shopId
      this.form.isMainland = result.data.isMainland
      this.form.designId = result.data.designId
      this.remitData = result.data
      this.productName = result.data.productName
    }else {
      let name = this.$route.query.name ? this.$route.query.name : ''
      this.productName = name
    }
    this.getConfigKey()


  },
};
</script>

<style lang="scss" scoped>
.amazon_edit {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .basic {
    padding: 0 0 0 32px;
  }
  .title {
    border-left: 4px solid #4934b2;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .basic ::v-deep .el-form-item__content {
    width: 720px;
  }
  .main ::v-deep .el-form-item__content {
    width: 720px;
  }
}
</style>
